// The mailbox's app password (the one a mail app uses for IMAP and SMTP).
//
// POST .../fdts/ replaces it: every mail app using the old one stops working.
// The page used POST just to show it, so looking at the password signed out
// every phone and desktop client. The api adds GET .../fdts/, which reads the
// current one without changing it (NM-API-15). Until that is deployed the
// api answers GET with 405, and only then does showing fall back to POST,
// which is what the page always did; `rotated` says which happened.
//
// `request(method)` performs the call and resolves to a fetch Response.
import { jsonBody } from './api-errors.js';

const NOT_ALLOWED = 405;

const outcome = async (res, rotated) => ({
  ok: res.ok, status: res.status, body: await jsonBody(res), rotated: res.ok && rotated,
});

export const revealAppPassword = async (request) => {
  const shown = await request('GET');
  if (shown.status !== NOT_ALLOWED) return outcome(shown, false);
  return outcome(await request('POST'), true);
};

export const rotateAppPassword = async (request) => outcome(await request('POST'), true);
